/* BENLING theme — vanilla JS, no dependencies.
   Modules: header, menu drawer, hero slider, carousels, scroll reveal, wishlist, localization. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  // Guard so re-running init (theme editor section reloads) never double-binds an element.
  var once = function (el, key) {
    var k = '__bnl_' + key;
    if (el[k]) return false;
    el[k] = true;
    return true;
  };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-site-header]');
    if (!header || !once(header, 'header')) return;
    var lastY = window.scrollY, ticking = false;
    /* home page: the bar stays out of sight while the hero video fills the screen and appears once the visitor scrolls past it */
    var heroEl = header.hasAttribute('data-over-hero') && !document.documentElement.classList.contains('is-design-mode') ? $('[data-hero]') : null;
    function busy() {
      return document.body.style.overflow === 'hidden' || header.classList.contains('is-searching') || !!header.querySelector('[data-nav-item].is-open') || header.contains(document.activeElement) && document.activeElement.matches('input, select, textarea');
    }
    var onScroll = function () {
      var y = window.scrollY;
      if (heroEl && heroEl.getBoundingClientRect().bottom > header.offsetHeight + 8 && !busy() && !header.contains(document.activeElement)) {
        header.classList.add('is-hidden'); header.classList.remove('is-scrolled');
        lastY = y; ticking = false; return;
      }
      header.classList.toggle('is-scrolled', y > 40);
      var dy = y - lastY;
      /* Sticky: once the visitor is past the hero the bar stays in view while they scroll up or down. */
      header.classList.remove('is-hidden');
      if (Math.abs(dy) > 4 || y < 90) lastY = y;
      ticking = false;
    };
    onScroll();
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }, { passive: true });
    header.addEventListener('focusin', function () { header.classList.remove('is-hidden'); });
  }

  /* ---------------------------------------------------------------- menu drawer */
  function initDrawer() {
    var drawer = $('[data-menu-drawer]');
    if (!drawer || !once(drawer, 'drawer')) return;
    var opener = $('[data-menu-open]');
    var closers = $$('[data-menu-close]', drawer);
    var panel = $('.menu-drawer__panel', drawer);
    var lastFocus = null;

    function focusables() {
      return $$('a[href], button:not([disabled])', panel).filter(function (el) { return el.offsetParent !== null; });
    }
    function open() {
      lastFocus = document.activeElement;
      drawer.removeAttribute('inert');
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var f = focusables();
      if (f.length) window.setTimeout(function () { f[0].focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      document.body.style.overflow = '';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (opener) opener.addEventListener('click', open);
    closers.forEach(function (c) { c.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    // Close if the viewport grows to desktop while open
    var minW = parseInt(drawer.getAttribute('data-min-width'), 10) || 1100;
    window.matchMedia('(min-width: ' + minW + 'px)').addEventListener('change', function (m) { if (m.matches && drawer.classList.contains('is-open')) close(); });
  }

  /* ---------------------------------------------------------------- navigation dropdowns + drawer accordions */
  /* Open / close one drawer drop-down with a smooth height + fade (instant for people who prefer reduced motion). */
  function setDrawerPanel(btn, panel, open) {
    if (!panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel.__done) { panel.removeEventListener('transitionend', panel.__done); panel.__done = null; }
    if (reduceMotion.matches) {
      panel.style.height = ''; panel.style.opacity = '';
      if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
      return;
    }
    function finish(e) {
      if (e && e.target !== panel) return;
      if (e && e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', finish);
      panel.__done = null;
      panel.style.height = '';
      if (!open) panel.setAttribute('hidden', '');
    }
    panel.__done = finish;
    panel.addEventListener('transitionend', finish);
    if (open) {
      panel.removeAttribute('hidden');
      panel.style.height = '0px'; panel.style.opacity = '0';
      void panel.offsetHeight;
      panel.style.height = panel.scrollHeight + 'px'; panel.style.opacity = '1';
    } else {
      panel.style.height = panel.getBoundingClientRect().height + 'px';
      void panel.offsetHeight;
      panel.style.height = '0px'; panel.style.opacity = '0';
    }
  }

  function initNav() {
    var items = $$('[data-nav-item]');
    function closeAll(except) {
      items.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var t = $('[data-nav-toggle]', item);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (item) {
      if (!once(item, 'nav')) return;
      var toggle = $('[data-nav-toggle]', item);
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        closeAll(item);
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(); toggle.focus(); }
      });
    });
    if (items.length && once(document.documentElement, 'navdoc')) {
      document.addEventListener('click', function (e) { if (!e.target.closest('[data-nav-item]')) closeAll(); });
    }
    $$('[data-drawer-toggle]').forEach(function (btn) {
      if (!once(btn, 'dtoggle')) return;
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (open) {
          /* one drop-down open at a time: the others fold up smoothly */
          $$('[data-drawer-toggle][aria-expanded="true"]').forEach(function (other) {
            if (other !== btn) setDrawerPanel(other, document.getElementById(other.getAttribute('aria-controls')), false);
          });
        }
        setDrawerPanel(btn, panel, open);
      });
    });
  }

  /* ---------------------------------------------------------------- hero (crossfade slider) */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      if (!once(hero, 'hero')) return;
      var slides = $$('[data-hero-slide]', hero);
      var dots = $$('[data-hero-dot]', hero);
      // Videos: only the visible slide plays; with reduced motion nothing autoplays (poster/first frame only).
      function syncVideos(active) {
        slides.forEach(function (s, i) {
          var v = $('video', s);
          if (!v) return;
          if (reduceMotion.matches || i !== active) { v.pause(); }
          else { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        });
      }
      if (reduceMotion.matches) $$('video', hero).forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
      syncVideos(0);
      if (slides.length < 2) return;
      var index = 0, timer = null, paused = false;
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && !reduceMotion.matches;
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 8000;

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === index;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        syncVideos(index);
      }
      function schedule() {
        window.clearTimeout(timer);
        if (autoplay && !paused) timer = window.setTimeout(function () { go(index + 1); schedule(); }, interval);
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); schedule(); }); });
      hero.addEventListener('mouseenter', function () { paused = true; window.clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { paused = false; schedule(); });
      hero.addEventListener('focusin', function () { paused = true; window.clearTimeout(timer); });
      hero.addEventListener('focusout', function () { paused = false; schedule(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) window.clearTimeout(timer); else schedule(); });
      go(0);
      schedule();
    });
  }

  /* ---------------------------------------------------------------- carousels (scroll-snap)
     Markup contract:
       [data-carousel]
         [data-carousel-track] > [data-carousel-slide]*
         [data-carousel-prev] / [data-carousel-next]
         [data-carousel-thumb]*        (optional: buttons that select a slide)
         [data-carousel-current] / [data-carousel-total]   (optional counters)
         [data-carousel-dot]*          (optional pagination)
         [data-carousel-progress]      (optional: element whose --progress is set 0..1) */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (root) {
      if (!once(root, 'carousel')) return;
      var track = $('[data-carousel-track]', root);
      var allSlides = $$('[data-carousel-slide]', root);
      if (!track || allSlides.length === 0) return;
      var visibleOnly = function (n) { return !n.hidden && !(n.parentElement && n.parentElement.hidden); };
      var slides = allSlides.filter(visibleOnly);
      var prev = $('[data-carousel-prev]', root), next = $('[data-carousel-next]', root);
      var allThumbs = $$('[data-carousel-thumb]', root);
      var thumbs = allThumbs.filter(visibleOnly);
      var dots = $$('[data-carousel-dot]', root);
      var current = $('[data-carousel-current]', root), total = $('[data-carousel-total]', root);
      var progress = $('[data-carousel-progress]', root);
      var index = 0, ticking = false;

      var fmt = root.hasAttribute('data-nopad') ? String : pad;
      if (total) total.textContent = fmt(slides.length);

      function slideLeft(i) { return slides[i].offsetLeft - track.offsetLeft; }
      function goTo(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slideLeft(i), behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
      }
      function render(i) {
        index = i;
        if (current) current.textContent = fmt(i + 1);
        if (progress) progress.style.setProperty('--progress', slides.length > 1 ? i / (slides.length - 1) : 1);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        thumbs.forEach(function (t, n) {
          t.setAttribute('aria-current', n === i ? 'true' : 'false');
          t.classList.toggle('is-active', n === i);
        });
        // Keep the active thumbnail visible when there are more thumbnails than fit in the row.
        if (thumbs[i]) {
          var row = thumbs[i].closest('ul');
          if (row && row.scrollWidth > row.clientWidth + 2) {
            var tile = thumbs[i].parentElement;
            row.scrollTo({ left: tile.offsetLeft - row.offsetLeft - (row.clientWidth - tile.offsetWidth) / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }
        }
        dots.forEach(function (d, n) {
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
          d.classList.toggle('is-active', n === i);
        });
        slides.forEach(function (s, n) { s.classList.toggle('is-current', n === i); });
      }
      function measure() {
        ticking = false;
        var left = track.scrollLeft, best = 0, bestD = Infinity;
        slides.forEach(function (s, n) {
          var d = Math.abs(slideLeft(n) - left);
          if (d < bestD) { bestD = d; best = n; }
        });
        // at the very end the last slide may never reach scrollLeft; treat it as current
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
        if (best !== index) render(best);
      }
      track.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(measure); } }, { passive: true });
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });
      allThumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(thumbs.indexOf(t)); }); });
      /* product gallery on a mouse device: pointing at a small photo shows it in the big picture straight away */
      if (root.hasAttribute('data-gallery-option') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        allThumbs.forEach(function (t) {
          t.addEventListener('mouseenter', function () { var i = thumbs.indexOf(t); if (i > -1 && i !== index) goTo(i, true); });
        });
      }
      /* the page hid / showed some slides (product photos of another colour): read the visible ones again and start from the first */
      root.addEventListener('carousel:refresh', function () {
        slides = allSlides.filter(visibleOnly);
        thumbs = allThumbs.filter(visibleOnly);
        if (total) total.textContent = fmt(slides.length);
        track.scrollTo({ left: 0, behavior: 'auto' });
        render(0);
      });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });
      window.addEventListener('resize', function () { goTo(index, true); });
      render(0);
    });
  }

  /* ---------------------------------------------------------------- muted looping clips that play only while visible ([data-autoplay-visible]) */
  function initVisibleVideos() {
    var vids = $$('video[data-autoplay-visible], video.insta__video');
    if (!vids.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return; /* poster only */
    /* the "Worn across India" clips play together: while that section is on screen every clip of it plays, none is held back */
    var groups = $$('.insta').map(function (sec) { return { sec: sec, vids: $$('video', sec) }; });
    vids = vids.filter(function (v) { return !v.closest('.insta'); });
    groups.forEach(function (g) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          $$('video', g.sec).forEach(function (v) {
            v.muted = true;
            if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else if (!v.paused) v.pause();
          });
        });
      }, { threshold: 0.12 }).observe(g.sec);
    });
    var inView = [];
    function balance() {
      var mid = window.innerHeight / 2;
      inView.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return Math.abs((ra.top + ra.bottom) / 2 - mid) - Math.abs((rb.top + rb.bottom) / 2 - mid);
      });
      vids.forEach(function (v) {
        var i = inView.indexOf(v);
        if (i > -1 && i < 3) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var i = inView.indexOf(e.target);
        if (e.isIntersecting && i < 0) inView.push(e.target);
        else if (!e.isIntersecting && i > -1) inView.splice(i, 1);
      });
      balance();
    }, { threshold: 0.35 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------------------------------------------------------------- warm up images
     Pictures below the fold are lazy so the first screen stays fast; once the page has loaded they are fetched quietly in the
     background, a few at a time, so they are already there when the visitor scrolls to them (no pop-in). */
  function initImageWarmup() {
    var conn = navigator.connection || {};
    if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')) return;
    var queue = [], busy = false, scrollTimer = 0;
    function collect() {
      var limit = window.scrollY + window.innerHeight * 6; /* only the next few screens, nearest first */
      queue = $$('img[loading="lazy"]').filter(function (img) { return !img.complete && !img.closest('[inert]') && img.offsetParent !== null; })
        .map(function (img) { return { img: img, top: img.getBoundingClientRect().top + window.scrollY }; })
        .filter(function (o) { return o.top < limit; })
        .sort(function (a, b) { return a.top - b.top; })
        .map(function (o) { return o.img; });
    }
    function pump() {
      var n = 0;
      while (queue.length && n < 3) {
        var img = queue.shift();
        if (img.complete) continue;
        img.loading = 'eager';
        n++;
      }
      if (queue.length) { busy = true; window.setTimeout(pump, 350); } else busy = false;
    }
    function start() {
      collect(); pump();
      window.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () { if (!busy) { collect(); pump(); } }, 400);
      }, { passive: true });
    }
    function whenIdle() { (window.requestIdleCallback || function (f) { window.setTimeout(f, 200); })(start); }
    if (document.readyState === 'complete') whenIdle(); else window.addEventListener('load', whenIdle, { once: true });
  }

  /* ---------------------------------------------------------------- infinite marquee ([data-marquee]) */
  function initMarquee() {
    if (reduceMotion.matches || designMode) return;
    $$('[data-marquee]').forEach(function (box) {
      if (!once(box, 'marquee')) return;
      var belt = $('.marquee__belt', box);
      var set = belt && belt.firstElementChild;
      if (!set) return;
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.removeAttribute('aria-label');
      $$('[id]', clone).forEach(function (n) { n.removeAttribute('id'); });
      $$('[data-carousel-track], [tabindex]', clone).forEach(function (n) { n.setAttribute('tabindex', '-1'); });
      belt.appendChild(clone);
      box.classList.add('is-marquee');
      var speed = parseFloat(box.getAttribute('data-marquee-speed')) || 40; /* px per second */
      var x = 0, period = 0, last = 0, raf = 0, visible = true, hover = false, dragging = false, resumeAt = 0, velocity = 0;
      var measure = function () { period = set.getBoundingClientRect().width; };
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      function wrap() { if (period > 0) { x = ((x % period) + period) % period - period; } }
      function paint() { belt.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)'; }
      function tick(t) {
        raf = 0;
        var dt = Math.min(48, t - (last || t)); last = t;
        if (!dragging) {
          if (Math.abs(velocity) > 0.02) { x += velocity * dt; velocity *= Math.pow(0.9, dt / 16); }
          else if (!hover && t > resumeAt) x -= speed * dt / 1000;
          wrap(); paint();
        }
        if (visible) raf = window.requestAnimationFrame(tick);
      }
      function start() { if (!raf && visible) { last = 0; raf = window.requestAnimationFrame(tick); } }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); }, { rootMargin: '200px' }).observe(box);
      }
      box.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
      box.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });

      /* drag / swipe: sideways movement pulls the belt; a picture gallery inside a card scrolls first until it reaches its end */
      var sx = 0, sy = 0, startX = 0, mode = '', trackEl = null, trackStart = 0, lastMoveX = 0, lastMoveT = 0, pid = null, moved = false;
      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        sx = e.clientX; sy = e.clientY; startX = x; mode = ''; moved = false; pid = e.pointerId;
        trackEl = e.target.closest ? e.target.closest('[data-carousel-track]') : null;
        trackStart = trackEl ? trackEl.scrollLeft : 0;
        lastMoveX = e.clientX; lastMoveT = e.timeStamp; velocity = 0;
      });
      box.addEventListener('pointermove', function (e) {
        if (pid === null || e.pointerId !== pid) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (!mode) {
          if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
          if (Math.abs(dy) > Math.abs(dx)) { pid = null; return; } /* a vertical swipe scrolls the page */
          var canScroll = trackEl && ((dx < 0 && trackEl.scrollLeft < trackEl.scrollWidth - trackEl.clientWidth - 2) || (dx > 0 && trackEl.scrollLeft > 2));
          mode = canScroll ? 'track' : 'belt';
          dragging = true; moved = true;
          box.classList.add('is-dragging');
          try { box.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        }
        if (mode === 'track') { trackEl.scrollLeft = trackStart - dx; }
        else {
          x = startX + dx; wrap(); paint();
          var dt = e.timeStamp - lastMoveT;
          if (dt > 0) velocity = Math.max(-2.5, Math.min(2.5, 0.7 * velocity + 0.3 * ((e.clientX - lastMoveX) / dt)));
          lastMoveX = e.clientX; lastMoveT = e.timeStamp;
        }
      });
      function release(e) {
        if (pid === null || (e && e.pointerId !== pid)) return;
        pid = null;
        if (mode === 'track' && trackEl) {
          var kids = Array.prototype.slice.call(trackEl.children), best = 0, gap = Infinity;
          kids.forEach(function (k, n) { var d = Math.abs(k.offsetLeft - trackEl.offsetLeft - trackEl.scrollLeft); if (d < gap) { gap = d; best = n; } });
          if (kids[best]) trackEl.scrollTo({ left: kids[best].offsetLeft - trackEl.offsetLeft, behavior: 'smooth' });
          velocity = 0;
        }
        dragging = false; box.classList.remove('is-dragging');
        resumeAt = performance.now() + 1800;
        mode = '';
        start();
      }
      box.addEventListener('pointerup', release);
      box.addEventListener('pointercancel', release);
      box.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { x += 220; wrap(); paint(); resumeAt = performance.now() + 2500; }
        if (e.key === 'ArrowLeft') { x -= 220; wrap(); paint(); resumeAt = performance.now() + 2500; }
      });
      start();
    });
  }

  /* ---------------------------------------------------------------- 3D tilt cards ([data-tilt]) */
  function initTilt() {
    if (reduceMotion.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('[data-tilt]').forEach(function (card) {
      if (!once(card, 'tilt')) return;
      var MAX = 7, frame = 0;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        if (frame) window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(function () {
          card.classList.add('is-tilting');
          card.style.setProperty('--ry', ((px - 0.5) * 2 * MAX).toFixed(2) + 'deg');
          card.style.setProperty('--rx', ((0.5 - py) * 2 * MAX).toFixed(2) + 'deg');
          card.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
          card.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', function () {
        if (frame) window.cancelAnimationFrame(frame);
        card.classList.remove('is-tilting');
        card.style.removeProperty('--rx'); card.style.removeProperty('--ry');
      });
    });
  }

  /* ---------------------------------------------------------------- stamps (A Benling icon, phones and tablets) */
  function initStamps() {
    var section = $('.icon-watch');
    var photo = section && $('.icon-watch__bg', section);
    if (!section || !photo || !once(section, 'stamps')) return;
    if (reduceMotion.matches || designMode || !('IntersectionObserver' in window)) return;
    section.classList.add('has-stamps');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.intersectionRatio >= 0.45) section.classList.add('is-stamped');
        else if (e.intersectionRatio === 0) section.classList.remove('is-stamped');
      });
    }, { threshold: [0, 0.45] }).observe(photo);
  }

  /* ---------------------------------------------------------------- scroll reveal */
  function initReveal() {
    var els = $$('[data-reveal]').filter(function (el) { return once(el, 'reveal'); });
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion.matches || designMode) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------- wishlist (client-side only) */
  function initWishlist() {
    var KEY = 'benling:wishlist';
    var saved = [];
    try { saved = JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { saved = []; }
    $$('[data-wishlist]').forEach(function (btn) {
      if (!once(btn, 'wish')) return;
      var id = btn.getAttribute('data-wishlist');
      var set = function (on) { btn.setAttribute('aria-pressed', on ? 'true' : 'false'); btn.classList.toggle('is-saved', on); };
      set(saved.indexOf(id) > -1);
      btn.addEventListener('click', function () {
        var i = saved.indexOf(id);
        if (i > -1) saved.splice(i, 1); else saved.push(id);
        set(i === -1);
        try { window.localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) { /* storage unavailable */ }
      });
    });
  }

  /* ---------------------------------------------------------------- localization selector */
  function initLocalization() {
    $$('[data-localization-select]').forEach(function (select) {
      if (!once(select, 'loc')) return;
      select.addEventListener('change', function () { if (select.form) select.form.submit(); });
    });
  }

  /* ---------------------------------------------------------------- auto-submit controls (collection sort, cart quantity) */
  function initAutosubmit() {
    $$('[data-autosubmit] select').forEach(function (select) {
      if (!once(select, 'auto')) return;
      select.addEventListener('change', function () { if (select.form) select.form.submit(); });
    });
    $$('[data-cart-qty]').forEach(function (input) {
      if (!once(input, 'cartqty')) return;
      input.addEventListener('change', function () { if (input.form) input.form.submit(); });
    });
  }

  /* ---------------------------------------------------------------- gifting form: optional customer email becomes the reply-to */
  function initGiftForm() {
    $$('[data-gift-email]').forEach(function (input) {
      if (!once(input, 'gift')) return;
      var form = input.form;
      var target = form && form.querySelector('[data-gift-email-target]');
      if (!target) return;
      var fallback = target.getAttribute('data-default') || '';
      input.addEventListener('input', function () {
        target.value = input.value && input.validity.valid ? input.value : fallback;
      });
    });
  }

  /* ---------------------------------------------------------------- tap-to-enlarge gallery images (native <dialog>) */
  function initLightbox() {
    $$('[data-lightbox]').forEach(function (box) {
      if (!once(box, 'lightbox')) return;
      var img = $('[data-lightbox-img]', box);
      var scope = box.parentElement;
      $$('[data-zoom]', scope).forEach(function (btn) {
        btn.addEventListener('click', function () {
          img.src = btn.getAttribute('data-zoom-src');
          img.alt = btn.getAttribute('data-zoom-alt') || '';
          if (typeof box.showModal === 'function') box.showModal(); else box.setAttribute('open', '');
        });
      });
      var close = function () { if (typeof box.close === 'function') box.close(); else box.removeAttribute('open'); };
      $$('[data-lightbox-close]', box).forEach(function (c) { c.addEventListener('click', close); });
      box.addEventListener('click', function (e) { if (e.target === box) close(); });
    });
  }

  /* ---------------------------------------------------------------- auto-advancing sliders (data-autoscroll="true") */
  function initAutoscroll() {
    $$('[data-autoscroll="true"]').forEach(function (track) {
      if (!once(track, 'autoscroll') || reduceMotion.matches) return;
      var root = track.closest('[data-carousel]');
      var next = root && $('[data-carousel-next]', root);
      if (!next) return;
      var timer = null, paused = false, visible = false;
      function tick() {
        if (paused || !visible || document.hidden) return;
        if (next.disabled) track.scrollTo({ left: 0, behavior: 'smooth' }); else next.click();
      }
      function start() { window.clearInterval(timer); timer = window.setInterval(tick, 5000); }
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { root.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) { root.addEventListener(ev, function () { paused = false; }, { passive: true }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(root); else visible = true;
      start();
    });
  }

  function init() {
    initAutoscroll();
    initLightbox();
    initGiftForm();
    initAutosubmit();
    initNav();
    initHeader(); initDrawer(); initHero(); initMarquee(); initCarousels(); initImageWarmup(); initVisibleVideos(); initTilt(); initStamps(); initReveal(); initWishlist(); initLocalization();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Shopify theme editor: re-initialise sections that were just (re)rendered.
  document.addEventListener('shopify:section:load', init);
})();
